import React from "react";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <>
      <Helmet>
        <title>Contact Tanarela - Get in Touch</title>
        <meta
          name="description"
          content="Contact Tanarela for premium landscape design materials. Visit our showroom in Laurenmouth, QLD or reach out via phone or email."
        />
        <meta property="og:title" content="Contact Tanarela" />
        <link rel="canonical" href="https://tanarela.com/contact" />
      </Helmet>

      <section className="contact-section">
        <div className="contact-container">
          <h1>Get in Touch with Tanarela</h1>

          <div className="contact-grid">
            <div className="contact-info">
              <h2>Contact Information</h2>

              <div className="contact-item">
                <FaHome className="contact-icon" />
                <div className="contact-details">
                  <h3>Visit Our Showroom</h3>
                  <p>157 Ann St</p>
                  <p>Brisbane City QLD 4000</p>
                  <p>Australia</p>
                </div>
              </div>

              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div className="contact-details">
                  <h3>Call Us</h3>
                  <p>Phone: +61485588246</p>
                  <p>Monday to Friday: 8:00 AM - 6:00 PM</p>
                  <p>Saturday: 9:00 AM - 4:00 PM</p>
                </div>
              </div>

              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div className="contact-details">
                  <h3>Email Us</h3>
                  <p>
                    <a href="mailto:tanarela@hotmail.com">
                      tanarela@hotmail.com
                    </a>
                  </p>
                  <p>We typically respond within 24 hours</p>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <h2>Send Us a Message</h2>

              {submitted && (
                <div
                  style={{
                    background: "#2C5F4F",
                    color: "white",
                    padding: "1rem",
                    borderRadius: "8px",
                    marginBottom: "1.5rem",
                    textAlign: "center",
                  }}
                >
                  Thank you for your message! We will get back to you soon.
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    pattern="^\+?[0-9\s\-]{7,20}$"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-contact-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          <div className="company-info">
            <h3>Tanarela Landscape Design Materials</h3>
            <p>
              <strong>Australian Business Number (ABN):</strong> 01456649
            </p>
            <p>
              We are proud to serve customers across Queensland and throughout
              Australia with premium natural stone products for landscape
              design. Visit our showroom to see our extensive collection or
              contact us for expert advice on selecting the perfect materials
              for your project.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
